<template>
  <div id="map-container">
    <div class="input-geo-div">
      <gmap-autocomplete id="map-search"
                        :options="options"
                         :disabled="disabledForm"
                         :value="value.address"
                         @place_changed="setPlace">
      </gmap-autocomplete>
    </div>
  </div>
</template>

<script>
import { tenantCode } from '@/mixins/tenants';

export default {
  name: 'InputSearchAddress',
  data() {
    return {
      input3: '',
      initialDir: '',
      options: {
        componentRestrictions: { country: 'CL' },
        fields: ['address_component', 'geometry', 'formatted_address'],
      },
      place: this.value,
    };
  },
  props: {
    value: {
      type: Object,
      default() {
        return {
          address: '',
          position: {
            lat: -33.435774,
            lng: -70.660690,
          },
          commune: '',
          locality: '',
        };
      },
    },
    address: {
      type: String,
      default: '',
    },
    disabledForm: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    this.options.componentRestrictions.country = tenantCode();
  },
  methods: {
    setPlace(gplace) {
      if (!gplace) return;
      if (!gplace.geometry) return;
      this.place.position.lat = gplace.geometry.location.lat();
      this.place.position.lng = gplace.geometry.location.lng();
      const streetAddress = gplace.address_components.filter(val => val.types.findIndex(el => el === 'street_address') >= 0);
      if (streetAddress.length > 0) {
        const routes = streetAddress[0].address_components.filter(val => val.types.findIndex(el => el === 'route') >= 0);
        const streetNumbers = streetAddress[0].address_components.filter(val => val.types.findIndex(el => el === 'street_number') >= 0);
        if (routes.length > 0) {
          this.location.route = routes[0].long_name;
        }
        if (streetNumbers.length > 0) {
          this.location.street_number = streetNumbers[0].long_name;
        }
      }
      const locality = gplace.address_components.filter(val => val.types.findIndex(el => el === 'locality') >= 0);
      const commune = gplace.address_components.filter(val => val.types.findIndex(el => el === 'administrative_area_level_3') >= 0);
      if (commune.length > 0) {
        this.place.commune = commune[0].long_name;
        this.place.locality = commune[0].long_name;
      }
      if (locality.length > 0) {
        this.place.locality = locality[0].long_name;
      }
      this.place.address = gplace.formatted_address;
      this.sendPlace();
    },
    sendPlace() {
      this.$emit('input', this.place);
      // this.$emit('sendPlaceToParent', this.place);
    },
  },
};
</script>

<style lang="scss" scoped>
  #map-container {
    margin-top: 0.3em;
    margin-bottom: 0.5em;
  }
  .input-geo-div {
    height: 38px;
    line-height: normal;
    display: inline-table;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
  }

  #map-search {
    vertical-align: middle;
    display: table-cell;
    font-size: 12px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    float: left;
    border: 1px solid #DCDFE6;
    color: $fb-grey-light-50;
    height: 38px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: calc(100% - 30px);
    -webkit-appearance: none;
    &:focus {
      border-color: $fb-green !important;
      outline: none !important;
    }
    &::placeholder {
      color: #b4b4b4;
    }
  }

  .map-search-button {
    border-color: transparent;
    background-color: $fb-green !important;
    color: $fb-grey-light-97 !important;
    display: table-cell;
    position: relative;
    height: 42px;
    width: 58px;
    &:hover {
      background-color: $fb-green-dark-10 !important;
      color: $fb-grey-light-97 !important;
    }
  }
</style>
